module.exports = __webpack_public_path__ + "img/5.211cc5da.jpg";